module.exports = __webpack_public_path__ + "img/empty-avatart.dde2545.png";